// src/components/Finances.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    Container,
    Typography,
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    TextField,
    Grid
} from '@mui/material';
const API_URL = process.env.REACT_APP_API_URL || '';

const Finances = () => {
    const [finances, setFinances] = useState([]);
    const [form, setForm] = useState({
        date: '',
        service_type: '',
        transaction_type: '',
        amount: '',
        status: '',
        due_date: '',
        description: ''
    });
    const token = localStorage.getItem('token');

    const fetchFinances = async () => {
        try {
            const response = await axios.get(`${API_URL}/api/finances`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setFinances(response.data);
        } catch (error) {
            console.error('Error fetching finances:', error);
        }
    };

    useEffect(() => {
        fetchFinances();
    }, [token]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${API_URL}/api/finances`, form, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchFinances();
            setForm({
                date: '',
                service_type: '',
                transaction_type: '',
                amount: '',
                status: '',
                due_date: '',
                description: ''
            });
        } catch (error) {
            console.error('Error adding finance record:', error);
        }
    };

    return (
        <Container maxWidth="lg">
            <Box sx={{ mt: 4 }}>
                <Typography variant="h4" gutterBottom>Finanse</Typography>
                <Paper sx={{ p: 2, mb: 4 }}>
                    <Typography variant="h6">Dodaj nowy rekord finansowy</Typography>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Data"
                                    name="date"
                                    type="date"
                                    value={form.date}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Typ usługi" name="service_type" value={form.service_type} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Typ transakcji" name="transaction_type" value={form.transaction_type} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField fullWidth label="Kwota" name="amount" type="number" value={form.amount} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField fullWidth label="Status" name="status" value={form.status} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    fullWidth
                                    label="Termin płatności"
                                    name="due_date"
                                    type="date"
                                    value={form.due_date}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField fullWidth label="Opis" name="description" value={form.description} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" color="primary">Dodaj rekord</Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
                <Paper sx={{ p: 2 }}>
                    <Typography variant="h6" gutterBottom>Lista rekordów finansowych</Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Data</TableCell>
                                <TableCell>Typ usługi</TableCell>
                                <TableCell>Typ transakcji</TableCell>
                                <TableCell>Kwota</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Termin płatności</TableCell>
                                <TableCell>Opis</TableCell>
                                <TableCell>Utworzony</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {finances.map(fin => (
                                <TableRow key={fin.id}>
                                    <TableCell>{fin.id}</TableCell>
                                    <TableCell>{fin.date}</TableCell>
                                    <TableCell>{fin.service_type}</TableCell>
                                    <TableCell>{fin.transaction_type}</TableCell>
                                    <TableCell>{fin.amount}</TableCell>
                                    <TableCell>{fin.status}</TableCell>
                                    <TableCell>{fin.due_date}</TableCell>
                                    <TableCell>{fin.description}</TableCell>
                                    <TableCell>{new Date(fin.created_at).toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            </Box>
        </Container>
    );
};

export default Finances;